import React from 'react';

const CustomFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column company-column">
          <img src="/logo.PNG" alt="IntelUniVen Logo" className="footer-logo" />
          <p className="company-info">IntelUniVen Software Solutions Private Limited</p>
          <p className="company-description">Transforming ideas into scalable digital solutions with innovation and precision.</p>
        </div>

        <div className="footer-column">
          <h4>Why IntelUniVen</h4>
          <ul>
            <li><a href="#">Discover</a></li>
            <li><a href="#">For Startups</a></li>
            <li><a href="#">Architecture</a></li>
            <li><a href="#">Research</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li><a href="/service">Web Development</a></li>
            <li><a href="/service">Mobile Apps</a></li>
            <li><a href="/service">ERP & LMS</a></li>
            <li><a href="/service">Custom Software</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><a href="#">Docs</a></li>  
            <li><a href="/about">Support</a></li>
            <li><a href="/academy">Academy</a></li>
            <li><a href="/verify">Certifications</a></li>
          </ul>
        </div>

        <div className="footer-column contact-column">
          <h4>Contact</h4>
          <ul>
            <li><i className="fas fa-envelope"></i> iuvsupport@inteluniven.com</li>
            <li><i className="fas fa-phone"></i> +91-8484052442</li>
            <li><i className="fas fa-map-marker-alt"></i> Pune India</li>
          </ul>
        </div>

        <div className="footer-column social-column">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61575605834519" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="https://linkedin.com/company/inteluniven" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="https://linkedin.com/company/inteluniven" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.instagram.com/inteluniven/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="https://linkedin.com/company/inteluniven" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            <a href="https://linkedin.com/company/inteluniven" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><i className="fab fa-github"></i></a>
          </div>
          <p className="social-text">Stay connected with us on social media for latest updates and tech insights.</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 IntelUniVen. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default CustomFooter;